module.exports = __webpack_public_path__ + "img/linkedin-icon.6899e3a9.svg";